import React from 'react';
import { GoChevronDown } from 'react-icons/go';
import Img from '../../../../../components/Img';
import Modal from '../../../../../components/Modal';
import VideoPlayer from '../../../../../components/VideoPlayer';
import { EVENT_SECTION_TYPE_V2 } from '../../../../../constants/service/app/eventConstants';
import WidgetPreviewProductItem from '../../../../widget/common/widgetPreview/widgetPreviewProduct/WidgetPreviewProductItem';
import EventAnimationSectionTypeImg from './EventAnimationSectionTypeImg';
import EventSwipeSectionTypeImg from './EventSwipeSectionTypeImg';
import './PreviewEventModal.scss';
import { TabsStyle } from './style';

const PreviewEventModal = (props) => {
  const { isOpen, closeModal, data } = props;
  const { eventPreviewData } = data;
  const { sectionInfoList, eventItemList, tabColorSet } = eventPreviewData;
  const tabTitleList = sectionInfoList
    .map((item, index) => ({ index, tabTitle: item.tabTitle }))
    .filter((item) => !!item.tabTitle);

  return (
    <Modal
      title="기획전 상세 미리 보기"
      wrapClassName="preview-event-modal-wrapper"
      isOpen={isOpen}
      width={375}
      height={685}
      isFooter={true}
      overflow="hidden"
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <div className="preview-event-modal">
        <div className="preview-area">
          <div className="event-section-list">
            {sectionInfoList.map((sectionInfoItem, index) => (
              <>
                {tabTitleList.length > 0 && tabTitleList[0].index === index && (
                  <TabsStyle
                    className={`tabs ${tabTitleList.length > 2 ? 'variable' : 'full'}`}
                    tabColorSet={tabColorSet}
                    tabLength={tabTitleList.length}
                  >
                    {tabTitleList.map((item, index) => (
                      <div key={index} className={`tab-title ${index === 0 ? 'active' : 'inactive'}`}>
                        {item.tabTitle}
                      </div>
                    ))}
                  </TabsStyle>
                )}
                <div className="event-section" key={index}>
                  {sectionInfoItem.eventSectionType === EVENT_SECTION_TYPE_V2.IMAGE ? (
                    <div className="event-img-section-type-wrap">
                      <Img
                        key={index}
                        clickAble={false}
                        src={sectionInfoItem.eventSectionImg[0] ? sectionInfoItem.eventSectionImg[0].url : null}
                      />
                      {sectionInfoItem.eventSectionClickLayerList.map((mapArea, index) => (
                        <div
                          className="area-link-item"
                          key={index}
                          style={{
                            top: mapArea.y + '%',
                            left: mapArea.x + '%',
                            width: mapArea.width + '%',
                            height: mapArea.height + '%',
                          }}
                        >
                          <a href={mapArea.url} target="_blank" rel="noreferrer" />
                        </div>
                      ))}
                    </div>
                  ) : sectionInfoItem.eventSectionType === EVENT_SECTION_TYPE_V2.VIDEO ? (
                    <div className="event-video-section-type-wrap">
                      <VideoPlayer
                        width={'100%'}
                        height={'100%'}
                        controls={true}
                        url={sectionInfoItem.eventSectionImg[0] ? sectionInfoItem.eventSectionImg[0].url : null}
                        loop
                        playing
                        muted
                        playsinline
                        config={{
                          vimeo: {
                            playerOptions: {
                              autoplay: true,
                              controls: true,
                              responsive: true,
                              width: '100%',
                              height: '100%',
                            },
                          },
                        }}
                      />
                    </div>
                  ) : sectionInfoItem.eventSectionType === EVENT_SECTION_TYPE_V2.ANIMATION ? (
                    <div className="event-animation-section-type-wrap">
                      <EventAnimationSectionTypeImg
                        imgList={sectionInfoItem.eventSectionImg}
                        transitionDelay={sectionInfoItem.transitionDelay}
                      />
                    </div>
                  ) : sectionInfoItem.eventSectionType === EVENT_SECTION_TYPE_V2.SWIPE ? (
                    <div className="event-swipe-section-type-wrap">
                      <EventSwipeSectionTypeImg
                        imgList={sectionInfoItem.eventSectionImg.map((item) => item.url)}
                        isInfinity={sectionInfoItem.isInfinity}
                      />
                    </div>
                  ) : sectionInfoItem.eventSectionType === EVENT_SECTION_TYPE_V2.TEXT ? (
                    <div className="event-text-section-type-wrap">{sectionInfoItem.title}</div>
                  ) : null}
                  {sectionInfoItem.eventSectionItemList.length ? (
                    <div className="event-section-item-list">
                      {sectionInfoItem.eventSectionItemList.map((productItem, index) => (
                        <WidgetPreviewProductItem key={index} productItem={productItem} isLike={false} />
                      ))}
                    </div>
                  ) : null}
                </div>
              </>
            ))}
          </div>
          <div className="filter">
            트랜드순
            <GoChevronDown />
          </div>
          <ul className="event-item-list">
            {eventItemList.map((productItem, index) => (
              <WidgetPreviewProductItem key={index} productItem={productItem} />
            ))}
          </ul>
        </div>
      </div>
    </Modal>
  );
};

export default PreviewEventModal;
